import { Medal, PawPrint } from "lucide-react";

export default function HallOfFame({ entries }) {
  return (
    <div className="glass rounded-3xl p-5 sm:p-6" data-testid="hall-of-fame">
      <h3 className="font-display text-lg font-bold flex items-center gap-2">
        <Medal className="h-5 w-5 text-amber-400" /> Hall of Fame
      </h3>
      <p className="font-mono-ui text-[10px] uppercase tracking-widest text-slate-500">Those who earned the purr</p>

      {(!entries || entries.length === 0) && (
        <p className="mt-4 text-sm text-slate-400" data-testid="hof-empty">No champions yet. Be the first to survive Muski.</p>
      )}

      <ul className="mt-4 space-y-2">
        {entries?.map((e, i) => (
          <li
            key={e.id}
            data-testid={`hof-entry-${i}`}
            className="flex items-center justify-between rounded-xl bg-slate-900/50 border border-white/5 px-3 py-2"
          >
            <div className="flex items-center gap-3">
              <span className={`font-display text-sm font-bold ${i === 0 ? "text-amber-400" : "text-slate-400"}`}>#{i + 1}</span>
              <span className="text-sm text-slate-200">{e.player_name}</span>
              {e.won && <span className="font-mono-ui text-[9px] rounded-full bg-emerald-500/15 text-emerald-300 px-2 py-0.5">PURR</span>}
            </div>
            <div className="flex items-center gap-3 font-mono-ui text-xs text-slate-400">
              <span className="text-sky-300">{e.affection}%</span>
              <span className="flex items-center gap-1"><PawPrint className="h-3 w-3 text-amber-400" />{e.ambushes_survived}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
